import { LoadingState } from '../../commonTypes'

export type Employee = {
  id: number
  firstName: string
  lastName: string
  middleName?: string | null
  designation: string
  fullName: string
  thumbPicture: string
  emailId: string
  mobile: string
  departmentName: string
  bloodgroup: string
  dateOfJoining: string
  country?: string | null
  relievingDate?: string
  underNoticeDate?: string
  resignationDate?: string
}

export type MockEmployee = {
  id: number
  firstName: string
  lastName: string
  middleName?: string | null
  designation: string
  fullName: string
  thumbPicture: string
  emailId: string
  mobile: string
  departmentName: string
  bloodgroup: string
  dateOfJoining: string
  country?: string | null
  [key: string]: unknown
}

export enum EmploymentStatus {
  'active' = 'Active',
  'contract' = 'Contract',
  'inactive' = 'InActive',
  'resigned' = 'underNotice',
  'pip' = 'PIP',
  'onContract' = 'On Contract',
  'onContractHire' = 'On Contract Hire',
}

export type updateHierarchyReportingManagerType = {
  employee: number
  newmanager: number
  oldmanager: number
}
export type updateHierarchyReportingManagerProps = {
  employee: number | string | undefined
  newmanager: number
  oldmanager: number
}
export type EmployeeListSliceState = {
  employees: Employee[]
  selectedEmploymentStatus: EmploymentStatus
  listSize: number
  isLoading: LoadingState
  isUpdated: boolean
  selectStatusValue: string
  updateHierarchyReportingManagerType: updateHierarchyReportingManagerType
  SelectCustom: string
  FromDateFilter: string | Date
  ToDateFilter: string | Date
  country: string
  searchInput: string
}

export type EmployeeListApiProps = {
  endIndex?: number
  startIndex?: number
  searchStr?: string
  selectionStatus?: string
  from?: string
  to?: string
  country?: string
  selectionDate?: string
}

export type GetEmployeeResponse = {
  emps: Employee[]
  Empsize: number
}

export type EmployeeListTableProps = {
  paginationRange: number[]
  currentPage: number
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>
  pageSize: number
  setPageSize: React.Dispatch<React.SetStateAction<number>>
  updateaccess?: boolean
  userEditAccess?: boolean
}
